import React from "react";

const UncheckIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    id="Livello_1"
    data-name="Livello 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 9"
    {...props}
  >
    <path
      // className="cls-1"
      d="M7.93,8.91H1.07a1,1,0,0,1-1-1V1.07a1,1,0,0,1,1-1H7.93a1,1,0,0,1,1,1V7.93A1,1,0,0,1,7.93,8.91ZM1.07,1.05l0,6.88L7.93,8a0,0,0,0,0,0,0V1.07Z"
    />
  </svg>
);

export default UncheckIcon;
